import { Theme } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  activeLink: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.primary.main)}, 0.3)`,
    border: `1px solid ${theme.palette.primary.main} !important`,
    borderRadius: 3,
  },
  buttonLink: {
    justifyContent: "flex-start",
    width: "100%",
  },
  center: {
    justifyContent: "center",
  },
  left: {
    justifyContent: "flex-start",
  },
  link: {
    "&:hover": {
      background: "#000",
      borderRadius: 3,
    },
    alignItems: "center",
    border: `1px solid transparent`,
    color: theme.palette.common.white,
    display: "flex",
    flexDirection: "row" as "row",
    height: "30px",
    padding: "1rem",
    textDecoration: "none",
    transition: "background 0.1s ease-out",
    width: "100%",
  },
  sidebarButton: {
    "&:focus-visible": {
      outline: "-webkit-focus-ring-color auto 1px",
      outlineOffset: "1px",
    },
  },
  text: {
    fontSize: 13,
    marginLeft: "0.5rem",
    padding: 5,
    whiteSpace: "nowrap" as "nowrap",
  },
});



// WEBPACK FOOTER //
// ./src/components/sidebar/components/SidebarLink/styles.ts